"use client";

import { Translate } from "@/components/Translate";
import { Tag } from "@/components/ui/Tags";
import { useLoyaltyProfile } from "@/features/loyalty/hooks";
import { useFlag } from "@/lib/flags/client";
import { useUser } from "@frend-digital/centra/client";
import styles from "./Header.module.css";

export const MobileAccountPoints = () => {
	const { data: user } = useUser();
	const loyaltyEnabled = useFlag("loyalty.enabled");

	// Only mount the value below (and its useLoyaltyProfile query) once we know
	// there's a logged-in user, so anonymous visitors don't fire a loyalty request.
	if (!user || !loyaltyEnabled) return null;

	return <MobileAccountPointsValue />;
};

const MobileAccountPointsValue = () => {
	const { data: loyaltyProfile } = useLoyaltyProfile();

	if (!loyaltyProfile) return null;

	return (
		<Tag
			outlined
			className={styles.navTag}
			style={
				{
					"--tag-color": "var(--stroke-1)",
					color: "var(--black)",
					paddingInline: "var(--spacing-4)",
					paddingBlock: "var(--spacing-2)",
					borderRadius: "var(--spacing-4)",
				} as React.CSSProperties
			}
		>
			<Translate>Bonus points</Translate>: {loyaltyProfile.points}
		</Tag>
	);
};
